import React, { useEffect, useState } from 'react';
import {
  ADMIN_ACCOUNT_NAVIGATION,
  UserColumns,
} from '../../../assets/constants/strings';
import SettingsTitle from '../SettingsTitle';
import { connect } from 'react-redux';
import Loader from '../../Loader';
import User from './User';
import '../style.scoped.scss';
import AddUserModal from './AddUserModal';
import $ from 'jquery';
import ConfirmationModal from './ConfirmationModal';
import { DeleteUser, UpdateClientRole } from '../../../store/User/userActions';

const Users = ({
  loading,
  usersByClient,
  DeleteUser,
  UpdateClientRole,
  user,
}) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [modalText, setModalText] = useState('');
  const [numberAdmin, setNumberAdmin] = useState();
  const [showConfirmationBtns, setShowConfirmationBtns] = useState(false);

  const addUserModalElement = document.getElementById('addUserModal');

  useEffect(() => {
    if (usersByClient) getNumberAdmins();
  });

  const getNumberAdmins = () => {
    let numberOfAdmin = 0;
    usersByClient.forEach((user) => {
      if (user.isAdmin) return numberOfAdmin++;
    });
    setNumberAdmin(numberOfAdmin);
  };

  const handleSelectedOption = (value, user) => {
    switch (value) {
      case 'CorporateAdmin': {
        if (!user.isAdmin) {
          setShowConfirm(true);
          setShowConfirmationBtns(true);
          setConfirmAction({ value: value, user: user });
          setModalText(
            'Are you sure you want to make user the admin? They will be able to view membership info and manage users.'
          );
        }
        break;
      }
      case 'CorporateBasic': {
        if (user.isAdmin && numberAdmin > 1) {
          setShowConfirm(true);
          setShowConfirmationBtns(true);
          setConfirmAction({ value: value, user: user });
          setModalText('Are you sure you want to remove user as admin?');
        } else {
          setShowConfirm(true);
          setShowConfirmationBtns(false);
          setModalText(
            'Cannot change roles for the only admin. Please add another admin before changing roles for this user.'
          );
        }
        break;
      }
      case 'Remove': {
        if (!user.isAdmin || (user.isAdmin && numberAdmin > 1)) {
          setShowConfirm(true);
          setShowConfirmationBtns(true);
          setConfirmAction({ value: value, user: user });
          setModalText(
            'Are you sure you want to remove this user? This user will no longer have access to RegulationCity.'
          );
        } else {
          setShowConfirm(true);
          setShowConfirmationBtns(false);
          setModalText(
            'Cannot delete the only admin. Please add another admin before deleting this user.'
          );
        }
        break;
      }
      default:
        return;
    }
  };

  const handleConfirm = async () => {
    if (confirmAction.value === 'Remove') {
      await DeleteUser(confirmAction.user.id);
      dismissModal();
    } else {
      await UpdateClientRole({
        clientId: user.clientId,
        userId: confirmAction.user.id,
        role: confirmAction.user.isAdmin ? 'CorporateBasic' : 'CorporateAdmin',
      });
      if (user.userID === confirmAction.user.id && confirmAction.user.isAdmin)
        window.location.reload();
      dismissModal();
    }
  };

  const dismissModal = () => {
    setShowConfirm(false);
    setModalText('');
    setConfirmAction(null);
  };

  return (
    <div className='users-frame' id='users-frame'>
      <SettingsTitle title={ADMIN_ACCOUNT_NAVIGATION.USERS.TITLE} />

      {/* only show spinner if modal is not showing */}
      {(!usersByClient || loading) &&
      (!addUserModalElement ||
        (addUserModalElement &&
          !addUserModalElement.className.match('show'))) ? (
        <div className='inner-load'>
          <Loader />
        </div>
      ) : (
        <React.Fragment>
          <div className='users-wrapper'>
            {usersByClient &&
            usersByClient.reason &&
            usersByClient.reason === 'Session Expired.' ? (
              <div className='card empty'>
                <div className='card-header'>
                  <b>Session Expired. Please restart the app.</b>
                </div>
              </div>
            ) : (
              <div className='title-row'>
                {UserColumns.map((col, i) => (
                  <div className={col.CSS} key={i}>
                    <p className='font-weight-bold'>{col.DISPLAY}</p>
                  </div>
                ))}
              </div>
            )}
            {usersByClient &&
              usersByClient.length > 0 &&
              usersByClient
                .filter((userByClient) => userByClient.id === user.userID)
                .map((userClient, i) => (
                  <User
                    key={i}
                    index={i}
                    user={userClient}
                    handleOption={handleSelectedOption}
                    isAdmin={userClient.isAdmin}
                    numberOfAdmin={numberAdmin}
                    disabledOptions={true}
                  />
                ))}
            {usersByClient && usersByClient.length > 0 ? (
              usersByClient
                .filter((userByClient) => userByClient.id !== user.userID)
                .sort((a, b) => (a.role > b.role ? 1 : -1))
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .map((userClient, i) => (
                  <User
                    key={i}
                    index={i}
                    user={userClient}
                    handleOption={handleSelectedOption}
                    isAdmin={userClient.isAdmin}
                    numberOfAdmin={numberAdmin}
                  />
                ))
            ) : (
              <div className='card empty'>
                <div className='card-header'>
                  No users saved yet. Click <b>Add</b> below to add a new user.
                </div>
              </div>
            )}

            {(() => {
              const cap = Number(user.activeUserTier) || 0;
              const used = usersByClient.length;
              const atCap = cap <= 0 || used >= cap;
              return (
                <div className='card-buttons-row'>
                  <span className='seats-used'>
                    {cap > 0 ? `${used} of ${cap} seats used` : 'No seats configured'}
                  </span>
                  <button
                    className='my-account-btn'
                    onClick={() => $('#addUserModal').modal('show')}
                    disabled={atCap}
                  >
                    Invite
                  </button>
                  {atCap && (
                    <p className='seats-full-note'>
                      {cap > 0
                        ? `You've used all ${cap} seats.`
                        : 'No seats are configured for your organisation.'}{' '}
                      Contact us to add more.
                    </p>
                  )}
                </div>
              );
            })()}

            <AddUserModal />

            <ConfirmationModal
              show={showConfirm}
              handleConfirm={handleConfirm}
              handleCancel={dismissModal}
              modalText={modalText}
              showConfirmationBtns={showConfirmationBtns}
            />
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  usersByClient: state.user.usersByClient,
  loading: state.user.loading,
  user: state.user.user,
});

const mapDispatchToProps = {
  DeleteUser,
  UpdateClientRole,
};

export default connect(mapStateToProps, mapDispatchToProps)(Users);
